import { Handshake, TrendingUp, Users, Package, ArrowRight } from "lucide-react";

const benefits = [
  { icon: Package, title: "Produk untuk Pasar Profesional", desc: "Acrylic sheet berkualitas dengan spesifikasi teruji." },
  { icon: Users, title: "Dukungan Konsultasi Produk", desc: "Tim kami membantu Anda memilih spesifikasi tepat." },
  { icon: TrendingUp, title: "Pembelian Jumlah Besar", desc: "Skema harga khusus untuk kebutuhan proyek besar." },
  { icon: Handshake, title: "Kerja Sama Jangka Panjang", desc: "Kemitraan berkelanjutan untuk pertumbuhan bersama." },
];

export const Partnership = () => {
  return (
    <section id="kemitraan" data-testid="partnership-section" className="py-24 lg:py-32 bg-animax-black text-white relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute -top-40 left-1/4 w-[500px] h-[500px] rounded-full bg-animax-yellow/10 blur-[120px]" />
        <div className="absolute bottom-0 right-0 w-[300px] h-[300px] rounded-full bg-animax-orange/10 blur-[100px]" />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <div className="tag-uppercase text-animax-yellow mb-4">Kemitraan & Distributor</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium leading-tight">
              Buka Peluang Kemitraan Bersama <span className="text-animax-yellow">ANIMAX Acrylic</span>
            </h2>
            <p className="mt-6 text-white/70 text-lg leading-relaxed">
              PT. Animax Putra Lancar membuka peluang kerja sama untuk distributor, reseller, toko bahan
              bangunan, workshop acrylic, dan mitra proyek di berbagai wilayah Indonesia.
            </p>

            <a
              href="#tim-sales"
              data-testid="partnership-cta"
              className="mt-10 group inline-flex items-center gap-2 px-7 py-4 rounded-full bg-animax-yellow text-animax-black font-medium text-sm hover:bg-white transition-all"
            >
              Hubungi Tim Kami
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>

          <div className="lg:col-span-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {benefits.map((b, i) => (
              <div
                key={i}
                data-testid={`partnership-benefit-${i}`}
                className="p-6 rounded-2xl border border-white/10 bg-white/5 hover:bg-white/10 hover:border-animax-yellow/40 transition-all card-lift"
              >
                <div className="w-11 h-11 rounded-xl bg-animax-yellow/20 flex items-center justify-center mb-4">
                  <b.icon className="w-5 h-5 text-animax-yellow" />
                </div>
                <h4 className="font-display text-base font-medium">{b.title}</h4>
                <p className="mt-2 text-xs text-white/60 leading-relaxed">{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
